<div class="content__inner">
    <header class="content__title">
        <h1>{{ "postcodeusers.list.title" | translate }}</h1>
        <small>{{ "postcodeusers.list.subtitle" | translate }}</small>
    </header>

    <div class="card" *appHasPermission="'POSTCODEUSERS.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "postcodeusers.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="firstname">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "postcodeusers.props.firstname" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.firstname }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="lastname">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "postcodeusers.props.lastname" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.lastname }}</td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "postcodeusers.props.email" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.email }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "postcodeusers.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date:UTCDATEFORMAT }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "postcodeusers.props.updated" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.updated | date:UTCDATEFORMAT }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <i (click)="showUserPostcodes(row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'POSTCODEUSERS.READ'"></i>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
